import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres82e/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres82e/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    let dtereserv = ''
    if (typeof searchParams !== 'undefined') {
      dtereserv = (typeof searchParams.dtereserv.replace(/\//g, '') !== 'undefined' ? searchParams.dtereserv.replace(/\//g, '') : '')
      sendParams = {
        p_roomno: (typeof searchParams.codroom !== 'undefined' ? searchParams.codroom : ''),
        p_timstrt: (typeof searchParams.timstrt !== 'undefined' ? searchParams.timstrt : ''),
        p_timend: (typeof searchParams.timend !== 'undefined' ? searchParams.timend : '')
      }
    }
    return instance().get(endpoint + '/hres82e/index/' + dtereserv, { params: sendParams })
  },
  getRoomDetail (searchParams) {
    if (isMock) return generator(mocker.roomDetail())
    const params = searchParams.roomno
    return instance().get(endpoint + '/hres82e/roomDetail/' + params)
  },
  getCalendar (searchParams) {
    if (isMock) return generator(mocker.calendar())
    let roomno = ''
    let dtemonth = ''
    let dteyear = ''
    if (typeof searchParams !== 'undefined') {
      roomno = (typeof searchParams.roomno !== 'undefined' ? searchParams.roomno : '')
      dtemonth = (typeof searchParams.dtemonth !== 'undefined' ? searchParams.dtemonth : '')
      dteyear = (typeof searchParams.dteyear !== 'undefined' ? searchParams.dteyear : '')
    }
    return instance().get(endpoint + '/hres82e/calendar/' + roomno + '/' + dtemonth + '/' + dteyear)
  },
  getCalendarDetail (searchParams) {
    if (isMock) return generator(mocker.calendarDetail())
    let roomno = ''
    let dtereserv = ''
    if (typeof searchParams !== 'undefined') {
      roomno = (typeof searchParams.roomno !== 'undefined' ? searchParams.roomno : '')
      dtereserv = (typeof searchParams.dtereserv.replace(/\//g, '') !== 'undefined' ? searchParams.dtereserv.replace(/\//g, '') : '')
    }
    return instance().get(endpoint + '/hres82e/calendarDetail/' + roomno + '/' + dtereserv)
  },
  // getReserveCreate (searchParams) {
  //   if (isMock) return generator(mocker.reserveCreate())
  //   let roomno = ''
  //   let dtereserv = ''
  //   if (typeof searchParams !== 'undefined') {
  //     roomno = (typeof searchParams.roomno !== 'undefined' ? searchParams.roomno : '')
  //     dtereserv = (typeof searchParams.dtereserv.replace(/\//g, '') !== 'undefined' ? searchParams.dtereserv.replace(/\//g, '') : '')
  //   }
  //   return instance().get(endpoint + '/hres82e/reserveCreate/' + roomno + '/' + dtereserv)
  // },
  getReserveDetail (searchParams) {
    if (isMock) return generator(mocker.reserveDetail())
    let roomno = ''
    let dtereserv = ''
    let seqno = ''
    if (typeof searchParams !== 'undefined') {
      roomno = (typeof searchParams.roomno !== 'undefined' ? searchParams.roomno : '')
      dtereserv = (typeof searchParams.dtereserv.replace(/\//g, '') !== 'undefined' ? searchParams.dtereserv.replace(/\//g, '') : '')
      seqno = (typeof searchParams.seqno !== 'undefined' ? searchParams.seqno : '')
    }
    return instance().get(endpoint + '/hres82e/reserveDetail/' + roomno + '/' + dtereserv + '/' + seqno)
  },
  postReserveCancel (cancelParams) {
    if (isMock) return generator(mocker.reserveCancel())
    return instance().post(endpoint + '/hres82e/reserveCancel', cancelParams)
  },
  postReserveSave (saveParams) {
    if (isMock) return generator(mocker.reserveSave())
    return instance().post(endpoint + '/hres82e/reserveDetailSave', saveParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres82e/index.js